import triggerTracking from '@blueprint/tracking';

export const trackListViewClick = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'map_search_results',
        eventAction: 'clickthrough',
        eventLabel: 'view_type_list'
    });
};
